<div *adaptLoading="!isInitialised"
     class="d-flex flex-column mw-100 gap-2">
    @if (survey) {
        @if (survey.status !== SurveyStatus.Ended) {
            <adapt-display-survey-result [survey]="survey"
                                         [hideName]="true"
                                         class="survey-result"></adapt-display-survey-result>
        }
        <div class="d-flex w-100 center-content">
            <button adaptButton="iconlessLink"
                    (click)="viewSurveySummary()">View survey summary</button>
        </div>
    }

    <adapt-show-workflow-meeting [workflowConnection]="workflowConnection"></adapt-show-workflow-meeting>
</div>
